<template>
    <div class="app-wrapper">
        <div class="main-content login">
            <div class="pink-half-circles-overlay main-content-inner">
                <div class="pink-half-circles-overlay__slot">
                    <div class="login-view__body-content">
                        <div class="intro-content">
                            <div class="intro-content">
                                <div class="heading">
                                    <img src="../assets/pink-half-circles.svg" alt="Visualise logo" class="logo" style="display: none;">
                                    <svg class="logo" viewBox="0 0 120 100" xmlns="http://www.w3.org/2000/svg" alt="Investment Growth Chart">
                                      <!-- Shaded areas between the data lines using violet tints -->
                                      <path d="M110 25 L90 30 L70 28 L50 32 L30 38 L10 38 L10 55 L30 55 L50 48 L70 45 L90 50 L110 48 Z"
                                            fill="var(--investment-violet)" opacity="0.4"/>
                                      <path d="M110 48 L90 50 L70 45 L50 48 L30 55 L10 55 L10 75 L30 75 L50 68 L70 65 L90 70 L110 68 Z"
                                            fill="var(--investment-violet)" opacity="0.6"/>

                                      <!-- Top data line -->
                                      <path d="M110 25 L90 30 L70 28 L50 32 L30 38 L10 38"
                                            stroke="var(--investment-violet)"
                                            stroke-width="3.5"
                                            fill="none"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"/>

                                      <!-- Middle data line -->
                                      <path d="M110 48 L90 50 L70 45 L50 48 L30 55 L10 55"
                                            stroke="var(--investment-violet)"
                                            stroke-width="3.5"
                                            fill="none"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"/>

                                      <!-- Bottom data line -->
                                      <path d="M110 68 L90 70 L70 65 L50 68 L30 75 L10 75"
                                            stroke="var(--investment-violet)"
                                            stroke-width="3.5"
                                            fill="none"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"/>

                                      <!-- Data points for top line -->
                                      <circle cx="110" cy="25" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="90" cy="30" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="70" cy="28" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="50" cy="32" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="30" cy="38" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="10" cy="38" r="3.5" fill="var(--investment-violet)"/>

                                      <!-- Data points for middle line -->
                                      <circle cx="110" cy="48" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="90" cy="50" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="70" cy="45" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="50" cy="48" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="30" cy="55" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="10" cy="55" r="3.5" fill="var(--investment-violet)"/>

                                      <!-- Data points for bottom line -->
                                      <circle cx="110" cy="68" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="90" cy="70" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="70" cy="65" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="50" cy="68" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="30" cy="75" r="3.5" fill="var(--investment-violet)"/>
                                      <circle cx="10" cy="75" r="3.5" fill="var(--investment-violet)"/>
                                    </svg>
                                    <h1 class="title non-selectable">LCP Investment Fee Survey</h1>
                                </div>
                                <p class="intro-text">Easily view investment manager fees by asset classes.</p>
                                <p class="intro-text-small">LCP is a leading investment consultancy at the forefront of advising companies and trustees on investment strategy, investment managers and related issues.</p>
                            </div>
                            <button class="p-button p-component" type="button" aria-label="Enter" @click="enterSite">
                                <span class="p-button-label">Enter</span>
                            </button>
                        </div>
                        <div class="policies-container">
                            <p class="terms-text">
                              <a href="/terms-and-conditions" target="_blank">Terms &amp; conditions</a> |
                              <a href="https://www.lcp.com/en/technology-services-privacy-policy" target="_blank">Privacy policy</a> | For further information about investment management fees and LCP's investment manager research please contact <a href="mailto:Matt.Gibson@lcp.com">Matt Gibson</a> or the partner that usually advises you.
                            </p>
                            <p class="copyright-text">All content &copy; copyright {{ currentYear }} <a href="https://www.lcp.com/en/investment" target="_blank">Lane Clark &amp; Peacock LLP</a>. All rights reserved.</p>
                        </div>
                    </div>
                </div>
                <div class="pink-half-circles-overlay__svg" aria-hidden="true">
                    <div class="pink-half-circles pink-half-circles--full-width">
                      <svg class="pink-half-circles__image" viewBox="0 0 960 960" xmlns="http://www.w3.org/2000/svg" style="opacity: 0.2;">
                        <!-- Decorative half circles pattern -->
                        <circle class="pulse-circle pulse-circle-1" cx="200" cy="400" r="150" fill="var(--investment-violet)" opacity="0.6"/>
                        <circle class="pulse-circle pulse-circle-2" cx="400" cy="200" r="130" fill="var(--investment-violet)" opacity="0.4"/>
                        <circle class="pulse-circle pulse-circle-3" cx="650" cy="500" r="180" fill="var(--investment-violet)" opacity="0.5"/>
                        <circle class="pulse-circle pulse-circle-4" cx="750" cy="250" r="140" fill="var(--investment-violet)" opacity="0.3"/>
                        <circle class="pulse-circle pulse-circle-5" cx="850" cy="550" r="115" fill="var(--investment-violet)" opacity="0.7"/>
                        <circle class="pulse-circle pulse-circle-6" cx="300" cy="650" r="90" fill="var(--investment-violet)" opacity="0.4"/>
                        <circle class="pulse-circle pulse-circle-7" cx="500" cy="150" r="100" fill="var(--investment-violet)" opacity="0.5"/>
                        <circle class="pulse-circle pulse-circle-8" cx="800" cy="750" r="80" fill="var(--investment-violet)" opacity="0.6"/>
                        <circle class="pulse-circle pulse-circle-9" cx="150" cy="700" r="120" fill="var(--investment-violet)" opacity="0.5"/>
                        <circle class="pulse-circle pulse-circle-10" cx="600" cy="350" r="110" fill="var(--investment-violet)" opacity="0.4"/>
                        <circle class="pulse-circle pulse-circle-11" cx="450" cy="750" r="95" fill="var(--investment-violet)" opacity="0.6"/>
                        <circle class="pulse-circle pulse-circle-12" cx="750" cy="650" r="105" fill="var(--investment-violet)" opacity="0.3"/>
                        <circle class="pulse-circle pulse-circle-13" cx="100" cy="200" r="85" fill="var(--investment-violet)" opacity="0.7"/>
                        <circle class="pulse-circle pulse-circle-14" cx="350" cy="450" r="125" fill="var(--investment-violet)" opacity="0.5"/>
                        <circle class="pulse-circle pulse-circle-15" cx="900" cy="350" r="75" fill="var(--investment-violet)" opacity="0.4"/>
                      </svg>
                      <svg class="plus plus-1" viewBox="0 0 500 500" preserveAspectRatio="xMidYMid meet">
                          <defs>
                              <radialGradient id="gradient1" cx="30%" cy="30%" r="70%">
                                  <stop offset="0%" style="stop-color:var(--investment-violet);stop-opacity:0.6" />
                                  <stop offset="40%" style="stop-color:var(--investment-violet);stop-opacity:0.8" />
                                  <stop offset="100%" style="stop-color:var(--investment-violet);stop-opacity:1" />
                              </radialGradient>
                          </defs>
                          <circle cx="250" cy="250" r="230" fill="url(#gradient1)" />
                      </svg>
                      <svg class="plus plus-2" viewBox="0 0 500 500" preserveAspectRatio="xMidYMid meet">
                          <defs>
                              <radialGradient id="gradient2" cx="25%" cy="35%" r="75%">
                                  <stop offset="0%" style="stop-color:var(--investment-violet);stop-opacity:0.5" />
                                  <stop offset="35%" style="stop-color:var(--investment-violet);stop-opacity:0.75" />
                                  <stop offset="100%" style="stop-color:var(--investment-violet);stop-opacity:1" />
                              </radialGradient>
                          </defs>
                          <circle cx="250" cy="250" r="230" fill="url(#gradient2)" />
                      </svg>
                      <svg class="plus plus-3" viewBox="0 0 500 500" preserveAspectRatio="xMidYMid meet">
                          <defs>
                              <radialGradient id="gradient3" cx="35%" cy="25%" r="65%">
                                  <stop offset="0%" style="stop-color:var(--investment-violet);stop-opacity:0.55" />
                                  <stop offset="45%" style="stop-color:var(--investment-violet);stop-opacity:0.8" />
                                  <stop offset="100%" style="stop-color:var(--investment-violet);stop-opacity:1" />
                              </radialGradient>
                          </defs>
                          <circle cx="250" cy="250" r="230" fill="url(#gradient3)" />
                      </svg>
                      <svg class="plus plus-4" viewBox="0 0 500 500" preserveAspectRatio="xMidYMid meet">
                          <defs>
                              <radialGradient id="gradient4" cx="40%" cy="30%" r="70%">
                                  <stop offset="0%" style="stop-color:var(--investment-violet);stop-opacity:0.6" />
                                  <stop offset="50%" style="stop-color:var(--investment-violet);stop-opacity:0.85" />
                                  <stop offset="100%" style="stop-color:var(--investment-violet);stop-opacity:1" />
                              </radialGradient>
                          </defs>
                          <circle cx="250" cy="250" r="230" fill="url(#gradient4)" />
                      </svg>
                      <svg class="plus plus-4" viewBox="0 0 500 500" preserveAspectRatio="xMidYMid meet">
                          <defs>
                              <radialGradient id="gradient4" cx="40%" cy="30%" r="70%">
                                  <stop offset="0%" style="stop-color:var(--investment-violet);stop-opacity:0.6" />
                                  <stop offset="50%" style="stop-color:var(--investment-violet);stop-opacity:0.85" />
                                  <stop offset="100%" style="stop-color:var(--investment-violet);stop-opacity:1" />
                              </radialGradient>
                          </defs>
                          <circle cx="250" cy="250" r="230" fill="url(#gradient4)" />
                      </svg>
                      <svg class="plus plus-4" viewBox="0 0 500 500" preserveAspectRatio="xMidYMid meet">
                          <defs>
                              <radialGradient id="gradient4" cx="40%" cy="30%" r="70%">
                                  <stop offset="0%" style="stop-color:var(--investment-violet);stop-opacity:0.6" />
                                  <stop offset="50%" style="stop-color:var(--investment-violet);stop-opacity:0.85" />
                                  <stop offset="100%" style="stop-color:var(--investment-violet);stop-opacity:1" />
                              </radialGradient>
                          </defs>
                          <circle cx="250" cy="250" r="230" fill="url(#gradient4)" />
                      </svg>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { onMounted } from 'vue'
    import { useRouter } from 'vue-router'
    import { useAnimationEngine } from '../composables/useAnimationEngine'
    import { useYear, DEFAULT_YEAR } from '../composables/useYear'
    import { useHead } from '@unhead/vue'
    import { BASE_URL } from '../config'

    const router = useRouter()
    const currentYear = new Date().getFullYear()
    const { selectedYear } = useYear()

    useHead({
        title: 'LCP Investment Fee Survey',
        titleTemplate: null,
        meta: [
            { name: 'description', content: 'Easily view investment manager fees by asset classes.' },
            { property: 'og:title', content: 'LCP Investment Fee Survey' },
            { property: 'og:description', content: 'Easily view investment manager fees by asset classes.' },
            { property: 'og:url', content: BASE_URL },
            { property: 'og:image', content: `${BASE_URL}/images/ifs-social.png` },
            { name: 'twitter:card', content: 'summary_large_image' },
            { name: 'twitter:title', content: 'LCP Investment Fee Survey' },
            { name: 'twitter:description', content: 'Easily view investment manager fees by asset classes.' },
            { name: 'twitter:image', content: `${BASE_URL}/images/ifs-social.png` }
        ]
    })

    // Initialize animation engine with configuration
    const animation = useAnimationEngine({
        containerSelector: '.pink-half-circles--full-width',
        elementSelector: '.plus',
        enableLogging: true, // Set to false to disable all logging
        effectDefaults: {
            scale: { from: 0.3, to: 0.5, speed: 5 },
            opacity: { from: 0.4, to: 0.5, speed: 5 },
            blur: { from: 3, to: 1, speed: 5 },
            color: { from: '#a250d6', to: '#a250d6', speed: 5 }
        },
        autoStart: true,
        // Configure individual rotation directions for each object
        rotationDirections: ['clockwise', 'anticlockwise', 'clockwise', 'anticlockwise'],
        rotationSpeed: 4, // Rotation speed per frame for all objects
        animationSpeed: 0.5 // Overall animation speed multiplier (low = slow, high = fast)
    })

    function enterSite() {
        // Stop animation when entering site
        animation.stop()
        // Always enforce 2026 data when entering via splash
        selectedYear.value = DEFAULT_YEAR // DEFAULT_YEAR is '2026'
        router.push({ name: 'contents', params: { year: DEFAULT_YEAR } })
    }

    onMounted(() => {
        // Small delay to ensure DOM is ready, then initialize animation
        setTimeout(() => {
            animation.initialize()
        }, 100)

        // Setup keyboard controls for development (Ctrl+Space to toggle)
        animation.setupKeyboardControls()
    })

</script>
<style lang="scss">
  :root {
    --plus-1-svg-width: 100px;
    --plus-1-svg-height: 100px;
    --plus-2-svg-width: 120px;
    --plus-2-svg-height: 120px;
    --plus-3-svg-width: 140px;
    --plus-3-svg-height: 140px;
    --plus-4-svg-width: 80px;
    --plus-4-svg-height: 80px;
  }
</style>
<style lang="scss" scoped>
// App wrapper - main container
.app-wrapper {
    display: grid;
    grid-template-rows: auto 1fr;
    grid-template-areas: "header" "main";
    height: 100dvh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    overflow: hidden;
    background-color: #141e34; /* Dark theme background */
    line-height: 1rem;

    .main-content {
        grid-area: main;
        overflow: hidden;

        .main-content-inner {
            height: 100%;
            width: 100%;
            overflow: hidden;
        }
    }
}

// Pink half-circles component
.pink-half-circles {
    display: inline-block;
    max-width: 100%;

    &--full-width {
        width: 100%;
        position: absolute;
    }

    &__image {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }
}

// Pink half-circles overlay
.pink-half-circles-overlay {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: #141e34;
    color: #fff;

    &__slot {
        position: absolute;
        left: 0;
        top: 0;
        width: 50%;
        height: 100%;
        z-index: 2;
        pointer-events: auto;

        @media (max-width: 1199.98px) {
            -webkit-backdrop-filter: blur(2px);
            backdrop-filter: blur(2px);
            width: 100%;
            left: 0;
        }
    }

    &__svg {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 50%;
        height: 100%;
        z-index: 1;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        pointer-events: none;
        overflow: hidden;

        .plus {
          position: absolute;
          top: 0;
          left: 0;
          pointer-events: none;
          will-change: transform, opacity, filter;
          transform-origin: center;
          visibility: hidden;

          // Use CSS custom properties for individual sizing
          &.plus-1 {
            width: var(--plus-1-svg-width);
            height: var(--plus-1-svg-height);
          }

          &.plus-2 {
            width: var(--plus-2-svg-width);
            height: var(--plus-2-svg-height);
          }

          &.plus-3 {
            width: var(--plus-3-svg-width);
            height: var(--plus-3-svg-height);
          }

          &.plus-4 {
            width: var(--plus-4-svg-width);
            height: var(--plus-4-svg-height);
          }
        }

        .pink-1 {
            width: 450px;
            height: 450px;
        }

        .pink-half-circles {
            width: 100%;
            height: 100%;
            max-width: none;
            object-fit: cover;
            object-position: bottom right;
            display: block;
        }

        @media (max-width: 1199.98px) {
            width: 100%;
            left: 0;
            right: 0;

            .pink-half-circles {
                width: 100%;
            }
        }
    }
}

// Login view body content
.login-view__body-content {
    display: grid;
    grid-template-rows: 1fr auto;
    height: 100dvh;
    padding: 50px 100px;
    gap: 30px;

    @media (max-width: 1199.98px) {
        width: 100vw;
        left: 0;
        position: relative;
        padding: 25px 50px;
        z-index: 3;
    }
}

// Intro content section
.intro-content {
    display: grid;
    place-content: center;
    height: 100%;
    gap: 30px;

    .heading {
        display: flex;
        gap: 20px;
        align-items: center;

        .logo {
            height: 100px;

            @media (max-width: 1199.98px) {
                height: 50px;
            }
        }

        .title {
            font-size: 2rem;
            line-height: 2.5rem;
        }
    }

    .p-button {
        width: fit-content;
    }

    .intro-text {
        font-size: 1.25rem;
        font-weight: 700;
        line-height: 1.4rem;
        margin: 0;

        &--bold {
            font-weight: 700;
        }
    }

    .intro-text-small {
        font-size: 0.9rem;
        line-height: 1.2rem;
        margin: 0;
    }
}

// Non-selectable utility
.non-selectable {
    cursor: default;
    -webkit-user-select: none;
    user-select: none;
}

// Policies container
.policies-container {
    display: flex;
    flex-direction: column;
    gap: 6px;


    a {
        font-size: 0.75rem;
        color: #fff;
        text-decoration: underline;
    }

    .copyright-text, .terms-text {
        font-size: 0.75rem;
        margin: 0;
    }
}

// PrimeVue button styling
.p-button {
    display: inline-flex;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    align-items: center;
    vertical-align: bottom;
    text-align: center;
    overflow: hidden;
    position: relative;
    color: #fff;
    background: var(--investment-violet);
    border: 1px solid var(--investment-violet);
    padding: 0.75rem 1.25rem;
    font-family: var(--montserrat), var(--fallback-fonts);
    font-size: 1rem;
    transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
    border-radius: 6px;
    outline-color: transparent;

    &:not(:disabled):hover {
        background: var(--toggle-background-investment-violet);
        color: #fff;
        border-color: var(--investment-violet);
    }

    &:not(:disabled):active {
        background: var(--investment-violet);
        color: #fff;
        border-color: var(--investment-violet);
    }

    &:focus-visible {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: 0 0 0 0.2rem #a7f3d0;
    }

    &:disabled {
        cursor: default;
    }

    &.p-component {
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
}

.p-button-label {
    font-family: var(--montserrat), var(--fallback-fonts);
    flex: 1 1 auto;
    transition-duration: 0.2s;
}

.p-ink {
    position: absolute;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    transform: scale(0);
    pointer-events: none;
}

// Toast notifications
.p-toast {
    &.p-toast-top-right {
        position: fixed;
        top: 20px;
        right: 20px;
    }

    &.p-toast-center {
        position: fixed;
        top: 50%;
        left: 50%;
    }
}

// SVG Logo styles
.cls-1 {
    fill: #e93f6f;
    stroke-width: 0;
}

.cls-2 {
    fill: #c90541;
    stroke-width: 0;
}

// Additional responsive breakpoints
@media (max-width: 767.98px) {
    .login-view__body-content {
        padding: 20px;
    }

    .intro-content {
        .heading {
            flex-direction: column;
            gap: 15px;

            .title {
                width: auto;
                text-align: center;
            }
        }

        .intro-text, .intro-text-small {
          text-align: center;
        }

        .p-button {
          justify-self: center;
        }
    }
}

@media (max-width: 480px) {
    .policies-container {
        .copyright-text {
            margin: 0 0 50px 0;
        }
    }
    .intro-content {
        .heading {
            .logo {
                height: 60px;
            }

            .title {
                font-size: 2rem;
            }
        }

        .intro-text {
            font-size: 1.25rem;
            line-height: 1.75rem;
        }

        .p-button {
          justify-self: center;
        }
    }
}

// Circle pulse animations - each circle pulses gently at different intervals
.pulse-circle {
    transform-origin: center;
    transition: transform 0.3s ease-out;
}

.pulse-circle-1 { animation: pulse-1 8s ease-in-out infinite; }
.pulse-circle-2 { animation: pulse-2 9s ease-in-out infinite; }
.pulse-circle-3 { animation: pulse-3 7s ease-in-out infinite; }
.pulse-circle-4 { animation: pulse-4 10s ease-in-out infinite; }
.pulse-circle-5 { animation: pulse-5 6s ease-in-out infinite; }
.pulse-circle-6 { animation: pulse-6 11s ease-in-out infinite; }
.pulse-circle-7 { animation: pulse-7 8.5s ease-in-out infinite; }
.pulse-circle-8 { animation: pulse-8 7.5s ease-in-out infinite; }
.pulse-circle-9 { animation: pulse-9 9.5s ease-in-out infinite; }
.pulse-circle-10 { animation: pulse-10 6.5s ease-in-out infinite; }
.pulse-circle-11 { animation: pulse-11 10.5s ease-in-out infinite; }
.pulse-circle-12 { animation: pulse-12 8.8s ease-in-out infinite; }
.pulse-circle-13 { animation: pulse-13 7.2s ease-in-out infinite; }
.pulse-circle-14 { animation: pulse-14 9.8s ease-in-out infinite; }
.pulse-circle-15 { animation: pulse-15 6.8s ease-in-out infinite; }

// Pulse keyframes - each circle has a unique animation with different delays
@keyframes pulse-1 {
    0%, 100% { transform: scale(1.0); }
    50% { transform: scale(0.8); }
}

@keyframes pulse-2 {
    0%, 100% { transform: scale(1.0); }
    40% { transform: scale(0.8); }
}

@keyframes pulse-3 {
    0%, 100% { transform: scale(1.0); }
    60% { transform: scale(0.8); }
}

@keyframes pulse-4 {
    0%, 100% { transform: scale(1.0); }
    35% { transform: scale(0.8); }
}

@keyframes pulse-5 {
    0%, 100% { transform: scale(1.0); }
    65% { transform: scale(0.8); }
}

@keyframes pulse-6 {
    0%, 100% { transform: scale(1.0); }
    45% { transform: scale(0.8); }
}

@keyframes pulse-7 {
    0%, 100% { transform: scale(1.0); }
    55% { transform: scale(0.8); }
}

@keyframes pulse-8 {
    0%, 100% { transform: scale(1.0); }
    30% { transform: scale(0.8); }
}

@keyframes pulse-9 {
    0%, 100% { transform: scale(1.0); }
    70% { transform: scale(0.8); }
}

@keyframes pulse-10 {
    0%, 100% { transform: scale(1.0); }
    25% { transform: scale(0.8); }
}

@keyframes pulse-11 {
    0%, 100% { transform: scale(1.0); }
    75% { transform: scale(0.8); }
}

@keyframes pulse-12 {
    0%, 100% { transform: scale(1.0); }
    42% { transform: scale(0.8); }
}

@keyframes pulse-13 {
    0%, 100% { transform: scale(1.0); }
    58% { transform: scale(0.8); }
}

@keyframes pulse-14 {
    0%, 100% { transform: scale(1.0); }
    48% { transform: scale(0.8); }
}

@keyframes pulse-15 {
    0%, 100% { transform: scale(1.0); }
    62% { transform: scale(0.8); }
}

</style>
